import dayjs from 'dayjs'
import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

export function getProposeTimeUserId(auth) {
    if (auth.getPractice().practiceType !== PracticeTypeEnum.ANCILLARY) {
        return auth.getActiveMember()?.id || auth.getUser().id
    }
}

export function buildProposeTimeQuery(auth, referral, locationId, distance) {
    const created = referral?.createdAt || referral?.createdDateTime
    return {
        physicianId: auth.getActiveMember()?.id || auth.getUser().id,
        practiceId: auth.getPractice().id,
        userId: getProposeTimeUserId(auth),
        practiceLocationId: locationId,
        fromUserId: referral?.fromUser?.id,
        timeFrame: referral?.timeframe,
        fromDate:
            referral?.timeframe === 'custom' && referral?.customDate
                ? dayjs(referral.customDate).format('YYYY-MM-DD')
                : created
                ? dayjs(created).format('YYYY-MM-DD')
                : undefined,
        distance: distance ?? undefined,
        practiceType: auth.getPractice().practiceType,
        isFromPatient: referral?.isFromPatient,
        patientId: referral?.patientId,
    }
}

export function goToProposeTime(router, auth, referralOrData, referralType = 'received') {
    const poolId = referralOrData.id || referralOrData.referralId
    if (!poolId) return

    const referral = referralOrData.id ? referralOrData : { id: poolId, referralId: poolId }

    router.push({
        name: 'referrals.pool.propose.time',
        params: { poolId, locationId: 0 },
        query: {
            referralType,
            pendingInit: '1',
            ...buildProposeTimeQuery(auth, referral, 0),
        },
    })
}
